module.exports = __webpack_public_path__ + "img/power_of_subconscious.820da2af.png";